const getApiUrl = () => {
    switch (process.env.NODE_ENV) {
      case 'development':
        return 'http://localhost:3001/api'; // Your local dev server
      case 'production':
        return 'https://agent-assistant-be.onrender.com/api'; // Your production API
      default:
        return 'http://localhost:8080/api';
    }
  };
  
  export const API_BASE_URL = getApiUrl();